import { CommonAPIService } from '@/servicehandlers/CommonHandler';

export class PaymentsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  async getPaymentMethods(router) {
    return this.CommonAPIService.getCall('/api/payments/payment_methods', null, router);
  }

  async getPaymentMethod(paymentMethodId, router) {
    return this.CommonAPIService.getCall(`/api/payments/payment_method/${paymentMethodId}`, null, router);
  }

  async getProducts(router) {
    return this.CommonAPIService.getCall('/api/payments/products', null, router);
  }

  async getSubscriptions(router) {
    return this.CommonAPIService.getCall('/api/payments/subscriptions', null, router);
  }

  async getSubscriptionSchedules(router) {
    return this.CommonAPIService.getCall('/api/payments/subscriptionschedules', null, router);
  }

  async getPrice(priceId, router) {
    return this.CommonAPIService.getCall(`/api/payments/price?priceId=${priceId}`, null, router);
  }

  async getUpcomingSubscriptions(router) {
    return this.CommonAPIService.getCall('/api/payments/upcoming_subscriptions', null, router);
  }
  
  async getInvoices(router) {
    return this.CommonAPIService.getCall('/api/payments/invoices', null, router);
  }

  async getPayments(router) {
    return this.CommonAPIService.getCall('/api/payments/payments', null, router);
  }
  
  async getIntents(router) {
    return this.CommonAPIService.getCall('/api/payments/setup_intents', null, router);
  }

  async setDefaultPaymentMethod(params, router) {
    return this.CommonAPIService.postCall('/api/payments/set_default_payment_method', params, router);
  }

  async deletePaymentMethod(params, router) {
    return this.CommonAPIService.postCall('/api/payments/delete_payment_method', params, router);
  }


  async changeSubscription(params, router) {
    return this.CommonAPIService.postCall('/api/payments/change_subscription', params, router);
  }




  async getCustomer(router) {
    return this.CommonAPIService.getCall('/api/payments/get_customer', null, router);
  }

  async getDefaultPaymentMethod(router) {
    return this.CommonAPIService.getCall('/api/payments/get_default_payment_method', null, router);
  }

  async getPhasedSubscriptions(router) {
    return this.CommonAPIService.getCall('/api/payments/phased_subscriptions', null, router);
  }

  async getKlarnaSubscriptions(router) {
    return this.CommonAPIService.getCall('/api/payments/klarna_subscriptions', null, router);
  }

  async addRenewal(params, router) {
    return this.CommonAPIService.postCall('/api/payments/add_renewal', params, router);
  }

  async stripeHook(params, router) {
    return this.CommonAPIService.postCall('/api/payments/stripehook', params, router);
  }

  async getKlarnaSession(router) {
    return this.CommonAPIService.getCall('/api/payments/get-klarna-session', null, router);
  }

  async updateCustomer(params, router) {
    return this.CommonAPIService.postCall('/api/payments/update_customer', params, router);
  }

  async updatePaymentMethod(paymentMethodId, params, router) {
    return this.CommonAPIService.postCall('/api/payments/update_payment_method', { paymentMethodId, ...params }, router);
  }

  async createPaymentMethod(params, router) {
    return this.CommonAPIService.postCall('/api/payments/create_payment_method', params, router);
  }

}
export default PaymentsAPIService;

